var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 64,
    viewBox: "0 0 200 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A4651",
    d: "M22.8566,35.0723 C22.8566,31.0753 26.0976,27.8343 30.0946,27.8343 C34.0926,27.8343 37.3336,31.0753 37.3336,35.0723 C37.3336,39.0703 34.0926,42.3103 30.0946,42.3103 C26.0976,42.3103 22.8566,39.0703 22.8566,35.0723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66B6CA",
    d: "M22.8566,58.0723 C22.8566,54.0753 26.0976,50.8343 30.0946,50.8343 C34.0926,50.8343 37.3336,54.0753 37.3336,58.0723 C37.3336,62.0703 34.0926,65.3103 30.0946,65.3103 C26.0976,65.3103 22.8566,62.0703 22.8566,58.0723"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3A4651",
    strokeDasharray: 4,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M15.0002,11.8496 L35.3332,11.8496"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#3A4651",
    fontFamily: "ApexSans-Book, Apex Sans",
    fontSize: 16.56,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.766,
    y: 17.79
  }, "Est. historical values")), /*#__PURE__*/React.createElement("text", {
    fill: "#3A4651",
    fontFamily: "ApexSans-Book, Apex Sans",
    fontSize: 16.56,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.766,
    y: 39.973
  }, "Recorded values")), /*#__PURE__*/React.createElement("text", {
    fill: "#3A4651",
    fontFamily: "ApexSans-Book, Apex Sans",
    fontSize: 16.56,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.766,
    y: 63.157
  }, "Projected values")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.fc36c07202d43ec26e0ad7997adb98d2.svg";
export { ForwardRef as ReactComponent };